var localeValues = {
  locale: 'zh-CN',
  Dialog: {
    okText: '确定',
    cancelText: '取消'
  },
  Toast: {
    cancelText: '取消'
  },
  Search: {
    actionText: '搜索'
  },
  Share: {
    copylink: '复制链接',
    copySuccess: '复制成功',
    loading: '加载中'
  }
};
export default localeValues;